var map = {
	"./footer.de-CH.json": 1059,
	"./footer.de-DE.json": 1060,
	"./footer.en-CA.json": 1061,
	"./footer.en-GB.json": 1062,
	"./footer.en-IN.json": 1063,
	"./footer.en-ME.json": 1064,
	"./footer.en-US.json": 1065,
	"./footer.es-EM.json": 1066,
	"./footer.es-ES.json": 1067,
	"./footer.fr-BE.json": 1068,
	"./footer.fr-CA.json": 1069,
	"./footer.fr-CH.json": 1070,
	"./footer.nl-BE.json": 1071,
	"./footer.nl-NL.json": 1072,
	"./footer.pl-PL.json": 1073,
	"./footer.pt-BR.json": 1074
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1058;